<script>
import { defineComponent } from 'vue'
import popperPositionedVuetifyDropdownMixin from '../../../../mixins/popperPositionedVuetifyDropdownMixin'

import { Portal } from '@linusborg/vue-simple-portal'

export default defineComponent({
    inheritAttrs: false,
    name: 'filter-select',
    components: { Portal },
    mixins: [popperPositionedVuetifyDropdownMixin],

    props: {
        items: Array,
        value: [Number, String],
        label: String,
        solo: Boolean,
        outlined: {
            type: Boolean,
            default: true
        },
        dense: {
            type: Boolean,
            default: true
        },
        showLabel: Boolean,
        popupUsedInModal: Boolean
    }
})
</script>

<template>
    <div>
        <v-select
            v-if="componentEnabled"
            ref="reference"
            :aria-label="label"
            :attach="$refs.anchor"
            :dense="dense"
            :items="items"
            :label="showLabel ? label : undefined"
            :menu-props="{
                transition: 'slide-y-transition',
                absolute: true,
                minWidth: 'max-content',
                maxHeight: 'max(226px, 50vh)'
            }"
            :outlined="outlined"
            :solo="solo"
            :value="value"
            flat
            hide-details
            v-bind="$attrs"
            v-on="$listeners"
        >
            <!-- https://stackoverflow.com/a/66062466 - pass through scoped slots -->
            <template v-for="(_, scopedSlotName) in $scopedSlots"
                      v-slot:[scopedSlotName]="slotData">
                <slot :name="scopedSlotName"
                      v-bind="slotData" />
            </template>
        </v-select>
        <portal>
            <div ref="anchor"
                 class="popper-menu-anchor"
                 :class="{'popper-menu-hide-under-navbar': !popupUsedInModal}"
            /><!--style="z-index: unset;"-->
        </portal>
    </div>
</template>

